import { useState, useCallback, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import { useSelector } from 'react-redux';
import useTranslations from '../translation/use-translations';
import { selectBrand } from '../brand/ducks/selectors.js';
import SeoContentSection from './seo-content-section';
import { SEO_CONTENT_PORTAL_ID } from './seo-content-portal';
import NullLoader from '~/components/null-loader.js';
import { ROUTE_PROMOTIONS } from '../router/constants';

let TEXT_KEYS = [];
let EXTENDED_TEXT_KEYS = [];
let ROUTES = [];
let mappingTextSEO = {};

const ContentSectionHelper = ({ translations, expanded, expand, path }) => {
	const key = mappingTextSEO[path];
	const firstPart = translations[key];
	const secondPart = translations[`${key}_PART2`];
	return (
		<SeoContentSection
			partOne={firstPart}
			partTwo={secondPart}
			readMoreText={translations.CONTENT_COMPONENT_READ_MORE}
			isExpanded={expanded}
			onExpand={expand}
		/>
	);
};

const Content = ({ isSelfExcluded, oldEnough }) => {
	const [expanded, setExpanded] = useState(false);
	const expand = useCallback(() => setExpanded(true), []);
	const location = useLocation();
	const { routesSEO } = useSelector(selectBrand);

	useEffect(() => {
		setExpanded(false);
	}, [location]);

	if (routesSEO) {
		mappingTextSEO = routesSEO;
		ROUTES = Object.keys(mappingTextSEO);
		TEXT_KEYS = Object.values(mappingTextSEO);
		EXTENDED_TEXT_KEYS = TEXT_KEYS.flatMap(textKey => [textKey, `${textKey}_PART2`]).concat(
			'CONTENT_COMPONENT_READ_MORE'
		);
	}

	const { translations, isLoadingTranslations } = useTranslations(EXTENDED_TEXT_KEYS);

	if ((!oldEnough || isSelfExcluded) && location.pathname === ROUTE_PROMOTIONS) {
		return null;
	}
	return (
		<>
			{/* This element is used to mount seo content from other features */}
			<div id={SEO_CONTENT_PORTAL_ID} />
			{!isLoadingTranslations && (
				<TracedRoutes>
					{ROUTES.map(path => (
						<Route
							key={path}
							path={path}
							element={
								<ContentSectionHelper
									translations={translations}
									expanded={expanded}
									expand={expand}
									path={path}
								/>
							}
						/>
					))}
					<Route path="*" element={<NullLoader />} />
				</TracedRoutes>
			)}
		</>
	);
};

export default Content;
